// extracted by mini-css-extract-plugin
export default {"wrapper":"w3-z","play":"x3-z"};